






















































import { Component, Mixins } from "vue-property-decorator";
import { Getter } from "vuex-class";
import { Asset } from "@foxone/api/src/models/wallet/mixin";
import mixins from "@/mixins";
import UserSelect from "wallet/components/withdraw/UserSelect.vue";
import UserItem from "wallet/components/withdraw/UserItem.vue";
import { MIXIN_SCHEME } from "@/constants";
import uuid from "uuid/v4";

@Component({
  components: {
    UserSelect,
    UserItem
  }
})
class WithdrawContact extends Mixins(mixins.page) {
  @Getter("wallet/mixin/getMergedAssets") mixinAssets!: Asset[];

  asset: any = null;

  amount = "";

  memo = "";

  user: any = null;

  result = true;

  searchError = false;

  showUserCard = false;

  get title() {
    return this.$t("wallet.withdraw.send-contact") as any;
  }

  get assets() {
    return this.mixinAssets.map(asset => {
      return {
        id: asset.asset_id,
        name: asset.name,
        symbol: asset.symbol,
        logo: asset.icon_url,
        priceUsd: asset.price_usd,
        balance: asset.balance,
        chainLogo: this.$common.utils.helper.getChainLogo(this, asset)
      };
    });
  }

  get valid() {
    return this.user && this.amount && this.asset;
  }

  get meta() {
    return {
      balance: this.asset?.balance
    };
  }

  mounted() {
    const id = this.$route.params.id;
    const asset = this.assets.find(asset => asset.id === id);
    this.asset = asset || null;
  }

  async pullTransferResult(data) {
    const setPaying = data => this.$store.commit("app/SET_PAYING", data);

    setPaying({ visible: true });
    const payment = await this.$api.wallet.mixin.verifyPayment(data);
    if (payment.status === "paid") {
      setPaying({ visible: false });
      this.handleToResult();
    } else {
      const timer = setTimeout(() => {
        this.pullTransferResult(data);
      }, 2000);
      setPaying({ timer });
    }
  }

  handleToResult() {
    this.$common.utils.helper.toFusionPath(
      this,
      "wallet",
      {
        name: "withdraw-result",
        query: {
          amount: this.amount,
          asset: encodeURIComponent(JSON.stringify(this.asset)),
          user: encodeURIComponent(JSON.stringify(this.user)),
          memo: encodeURIComponent(this.memo)
        }
      },
      true
    );
  }

  handleTransfer() {
    const asset = this.asset?.id;
    const trace = uuid();
    const amount = this.amount;
    const recipient = this.user?.user_id;
    const memo = this.memo;
    const scheme = `${MIXIN_SCHEME.PAY}?asset=${asset}&trace=${trace}&amount=${amount}&recipient=${recipient}&memo=${memo}`;
    window.location.href = scheme;
    this.pullTransferResult({
      amount,
      asset_id: asset,
      opponent_id: recipient,
      trace_id: trace
    });
  }

  handleUserClick() {
    this.showUserCard = false;
    this.$nextTick(() => {
      const userSelect = this.$refs["userSelect"] as any;
      const input = userSelect?.$el.querySelector("input");
      input.focus();
    });
  }

  handleSearchError() {
    this.searchError = true;
  }

  handleSearched() {
    this.showUserCard = true;
    this.searchError = false;
  }

  handleFillBalance() {
    console.log("handleFillBalance");
    this.amount = this.meta?.balance;
  }
}
export default WithdrawContact;
